import React, { useState, useEffect } from 'react';
import axios from './AxiosConfig';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { Helmet } from 'react-helmet';
import styles from './styles/loginForm.module.css';

const LoginForm = ({ onNextStep }) => {
  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error,   setError]   = useState('');

  // 1) Bootstrap CSRF una sola volta
  useEffect(() => {
    axios.get('/api/csrf/', { withCredentials: true })
      .then(() => console.log('CSRF cookie impostato'))
      .catch((err) => {
        console.log('CSRF bootstrap failed:',
          { msg: err?.message, status: err?.response?.status, data: err?.response?.data });
      });
  }, []);

  const togglePasswordVisibility = () => setShowPassword((s) => !s);
  // 🔹 Pulisce gli errori quando si clicca in un campo
  const handleFieldFocus = () => {
    if (error) setError('');
  };
  const handleLogin = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await axios.post('/api/login/', { username, password }, { withCredentials: true });
      console.log('Login OK:', res.status, res.data);
      if (res.data?.redirect === 'generate_qr') onNextStep('generate_qr');
      else if (res.data?.redirect === 'verify_otp') onNextStep('verify_otp');
    } catch (err) {
      // 2) Catch compatto ma informativo
      console.log('Login error:', {
        message: err?.message,
        status: err?.response?.status,
        statusText: err?.response?.statusText,
        data: err?.response?.data
      });
      setError(err?.response?.data?.message || err?.response?.data?.error ||  err?.response?.data?.detail || 'Login failed');
      setPassword('');
      setShowPassword(false);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => { e.preventDefault(); handleLogin(); };

  return (
    <div className={`col-12 col-md-6 col-lg-4 ${styles.lato_form}`}>
      <Helmet><title>Login</title></Helmet>

      <div className={`p-4 border rounded ${styles.containerloginform}`}>
        <div className={`p-4 border rounded ${styles.containerTesto}`}>
          <h2 className="mb-4">Accedi</h2>
        </div>

        <div className={styles.messaggioErrore}>
          {error && <div className="alert alert-danger">{error}</div>}
          {loading && <div className="alert alert-info">Accesso in corso...</div>}
        </div>

        <div className={styles.login_form}>
          <form onSubmit={handleSubmit}>
            <div className="form-group mb-3">
              <label htmlFor="username">Username:</label>
              <input id="username" className="form-control" value={username}
                    onChange={(e) => setUsername(e.target.value)} 
                    onFocus={handleFieldFocus}    
                    required />
            </div>

            <div className="form-group mb-3">
              <label htmlFor="password">Password:</label>
              <input id="password" className="form-control"
                    type={showPassword ? 'text' : 'password'}
                    value={password} onChange={(e) => setPassword(e.target.value)} 
                    onFocus={handleFieldFocus}    
                    required />
              <div className={styles.lookpassword}>
                <i className="bi bi-eye-fill" onClick={togglePasswordVisibility} role="button" />
              </div>
            </div>

            <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
              {loading ? 'Attendere…' : 'Avanti'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
